export function Title({ title }: { title: string }) {
  return (
    <div
      className='text-start text-2xl font-semibold text-black'
      data-testid='header-title'
    >
      {title}
    </div>
  );
}
